// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  beta: false,
  msal: {
    auth: {
        clientId: '24967ca2-8989-4783-85be-0a7c32f72e13',
        authority: 'https://login.microsoftonline.com/6f475f3a-9d6b-4413-904b-975d37cd3768'
    }
  },
  umami: "",
  v4: "http://localhost:8000"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
